import { Card, CardContent } from "@/components/ui/card";
import { FullScreenCalendar } from "@/components/ui/fullscreen-calendar";

//// example input
// const data = [
//   {
//     day: new Date(2025, 2, 21), // March 21, 2025
//     events: [
//       {
//         id: 1,
//         name: "Meeting with team",
//         time: "10:00 AM",
//       },
//       {
//         id: 2,
//         name: "Lunch with client",
//         time: "1:00 PM",
//       },
//     ],
//   },
//   {
//     day: new Date(2025, 2, 22), // March 22, 2025
//     events: [
//       {
//         id: 3,
//         name: "Project deadline",
//         time: "All day",
//       },
//     ],
//   },
// ];

function PursuitCalendar({ events }) {
  return (
    <Card className="bg-background">
      <CardContent className="flex-1 p-0">
        <FullScreenCalendar data={events} />
      </CardContent>
    </Card>
  );
}

export { PursuitCalendar };
